import { createUseStyles } from 'react-jss';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { NegativeColors, PositiveColors } from '@picsart/design-system/foundation/colors';

const useStyles = createUseStyles<string, { acBackground?: string }>(
  {
    root: {
      width: '100%',
      height: '1800px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: ({ acBackground }) => acBackground || NegativeColors.base.default,

      '@media screen and (max-width: 1024px)': {
        height: '1400px',
      },
    },
    wrapper: {
      height: '100%',
    },
    container: {
      position: 'relative',
      width: '100%',
      margin: '0 auto',
      height: '100%',
      clipPath: 'inset(0 0 0 0)',
      display: 'flex',
      alignItems: 'flex-start',
    },
    image: {
      position: 'absolute',
      borderRadius: CornerRadius.r12,
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      objectFit: 'cover',

      '@media screen and (max-width: 1024px)': {
        maxWidth: 180,
        objectFit: 'scale-down',
      },
      '@media screen and (max-width: 680px)': {
        maxWidth: 160,
      },
    },
    button: {
      position: 'sticky',
      margin: '25rem auto',
      textAlign: 'center',
      top: '20%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '14rem',

      '@media screen and (max-width: 1024px)': {
        margin: '20rem auto',
        height: '12rem',
      },

      '@media screen and (max-width: 768px)': {
        margin: '15rem auto',
        height: '10rem',
      },

      '& a': {
        transform: 'scale(3.5)',
        width: 220,
        boxShadow: `0px 0px 8px 0px ${PositiveColors.base.default}`,
        borderRadius: '100px',

        '@media screen and (max-width: 1440px)': {
          width: 200,
        },

        '@media screen and (max-width: 1024px)': {
          transform: 'scale(2.8)',
        },

        '@media screen and (max-width: 768px)': {
          transform: 'scale(2)',
        },

        '@media screen and (max-width: 520px)': {
          transform: 'scale(1.5)',
        },
      },
    },
  },
  { name: 'animated-cards' },
);

export default useStyles;
